import React from "react";

const ExportCsvDateWise = ({
  jsonData,
  username = "all",
  start_date,
  end_date,
  project = "all",
}) => {
  const handleExportCsv = () => {
    const csvData = [];

    if (!jsonData || typeof jsonData !== "object") {
      console.error("Invalid jsonData:", jsonData);
      return;
    }

    // Process each entry in jsonData
    for (const date in jsonData) {
      if (jsonData.hasOwnProperty(date)) {
        const data = jsonData[date];
        const totalHours = data.totalHours;

        if (!data.entries || !Array.isArray(data.entries)) {
          console.warn("No entries found for date:", date);
          continue;
        }

        // Build CSV data rows
        data.entries.forEach((entry) => {
          console.log("Entry", entry);
          const projectName = entry.field_proj
            ? entry.field_proj.projectName
            : "No Project";
          csvData.push({
            "Employee Id": entry?.uid?.employeeId,
            Name: `${entry.uid.fname} ${entry.uid.lname}`,
            "Employee Type": entry?.uid?.employmentStatus,
            Date: entry?.field_entrydate,
            "Ticket Number": entry?.field_ticket_number,
            Project: projectName,
            Task: entry.field_entrytask,
            Description: entry.body, // Supports multi-line descriptions
            TimeSpent: entry.field_time_spent,
            "Post Date": formatDate(entry?.field_entrydate),
            Email: entry.uid.email,
            TotalHours: totalHours,
          });
        });
      }
    }

    if (csvData.length === 0) {
      console.warn("No valid CSV data to export");
      return;
    }

    // Define headers
    const headers = {
      "Employee Id": "Employee Id",
      Name: "Name",
      "Employee Type": "Employee Type",
      Date: "Date",
      "Ticket Number": "Ticket Number",
      Project: "Project Name",
      Task: "Task",
      Description: "Description",
      TimeSpent: "Time Spent (hours)",
      "Post Date": "Post Date",
      Email: "Email",
    };

    // Call export function
    exportToCsv(
      csvData,
      headers,
      `timesheet_entries_${username}_${start_date}_${end_date}_${project}.csv`
    );
  };

  const exportToCsv = (data, headers, filename) => {
    // Filter out "TotalHours" from headers
    const filteredHeaders = Object.entries(headers).filter(
      ([key]) => key !== "TotalHours"
    );
    const headerKeys = filteredHeaders.map(([key]) => key);

    const csvContent = [
      // Header row
      filteredHeaders.map(([, value]) => `"${value}"`).join(","),

      // Data rows
      ...data.map((row) =>
        headerKeys
          .map((key) => {
            const value = row[key] ?? ""; // Ensure undefined values are empty
            return `"${String(value)
              .replace(/"/g, '""')
              .replace(/\n/g, "\r\n")}"`;
          })
          .join(",")
      ),
    ].join("\n");

    // Create and trigger CSV download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <button
        className="py-2 bg-[#ff480f] px-4 text-base text-white rounded w-full md:w-fit"
        onClick={handleExportCsv}
      >
        Export Timesheet CSV
      </button>
    </div>
  );
};

function formatDate(dateString) {
  const date = new Date(dateString);
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return date.toLocaleDateString("en-US", options);
}

export default ExportCsvDateWise;
